import InvelpsGlobalNav from "./InvelpsGlobalNav";
import useInvelpsTheme from "../hooks/useInvelpsTheme";

/** En-tête unique : barre verte INVELPS (nav + Leaders / Flux intégrés) */
export default function MarketPageShell() {
  const { darkMode, toggleDark } = useInvelpsTheme();

  return (
    <InvelpsGlobalNav
      darkMode={darkMode}
      onToggleDark={toggleDark}
    />
  );
}
